import { Briefcase, ExternalLink } from "lucide-react"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"

import { Button, Card, CardContent } from "@f2e/ui/components/base"

import { Workspace } from "@/types"

export interface WorkspaceUsageListProps {
  workspaces: Workspace[]
}

const WorkspaceUsageList = ({ workspaces }: WorkspaceUsageListProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (workspaces.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <Briefcase className="h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-muted-foreground">
          {t("brands.workspaces.noWorkspaces")}
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-2">
      <div className="text-sm text-muted-foreground mb-4">
        {t("brands.workspaces.count", { count: workspaces.length })}
      </div>
      <div className="grid gap-2">
        {workspaces.map((workspace) => (
          <Card
            key={workspace.id}
            className="hover:shadow-xs transition-shadow"
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                    <Briefcase className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-medium">{workspace.name}</p>
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate(`/workspaces/${workspace.id}`)}
                >
                  {t("brands.workspaces.viewWorkspace")}
                  <ExternalLink className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default WorkspaceUsageList
